<template>
  <Column class="AppLayout">
    <component
      :is="currentHeader"
      v-if="!route.query.winId && !headerHide"
      class="w-100b"
      :class="headerFixed ? 'header-fixed' : ''"
    />
    <!-- <div
      v-if="headerFixed && !headerHide"
      :headerHide="headerHide"
      class="h-59"
    /> -->
    <router-view v-slot="{ Component }">
      <Column class="w-100b " :class="['/user/register', '/login'].includes(businessPath) ? 'app-body2' : 'app-body'">
        <!-- <Announcement /> -->
        <EntryDiaManage />
        <Component
          :is="Component"
          :class="className"
        />
      </Column>
    </router-view>
    <AppFooter v-if="!footerHide" class="w-100b" />

  </Column>
</template>

<script setup>
import { getBusinessPath } from '@/utils/localeRoute.js'
import AppHeader from './appHeader/AppHeader.vue'
import CoinStockHeader from './appHeader/CoinStockHeader.vue'
import EcoHeader from './appHeader/EcoHeader.vue'

const route = useRoute()
const props = defineProps({
  price: {},
  amount: {},
  total: {},
  percent: {},
  type: {}
})
const businessPath = $computed(() => getBusinessPath(route.path))

const footerHidePage = ['/ru', '/coinStockTrade', '/coinStockFutures', '/trade', '/futures', '/404', '/docsApi']
const headerHidePage = ['/ru']

const footerHide = $computed(() => {
  return footerHidePage.includes(businessPath)
})
const headerHide = $computed(() => {
  return headerHidePage.includes(businessPath)
})

const currentHeader = $computed(() => {
  // 定义需要使用新导航栏的路径
  if (businessPath.startsWith('/ecoV2') || route.meta?.header === 'EcoHome') {
    return EcoHeader
  }
  const coinStockPaths = ['/coinStock', '/coinStockTrade', '/coinStockFutures', '/coinStockConvert', '/ipo', '/ipo/subscription', '/bffund']
  if (coinStockPaths.includes(businessPath) || route.meta?.header === 'coinStock') {
    return CoinStockHeader
  }
  return AppHeader
})

const className = $computed(() => {
  if (route.query.winId) {
    return ['componentIframe', 'w-100b', 'bg-d']
  } else if (headerHide == false && footerHide == true) {
    return ['', 'w-100b', 'bg-d']
  } else if (headerHide == true && footerHide == true) {
    return ['hideHF', 'w-100b', 'bg-d']
  } else {
    return ['component', 'w-100b', 'bg-d']
  }
})
const headerFixed = $computed(() => {
  return true
})

onBeforeMount(() => { })
</script>

<style lang="scss">
.AppLayout {
  width: 100%;
  .header-fixed {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    background-color: #fff;
  }
  .component {
    min-height: calc(100vh - 420px);
  }
  .componentIframe{
    min-height: calc(100vh - 350px);
  }
  .hideHF{
    min-height: 100vh;
  }
  .app-body{
    min-height: calc(100vh - 60px - 482px);
  }
  .app-body2{
    min-height: calc(100vh - 60px );
  }
}
</style>
